/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type TimingFactor = (typeof TimingFactor)[keyof typeof TimingFactor];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimingFactor = {
  FIVE: "FIVE",
  TEN: "TEN",
  FIFTEEN: "FIFTEEN",
  TWENTY: "TWENTY",
  TWENTY_FIVE: "TWENTY_FIVE",
  THIRTY: "THIRTY",
  THIRTY_FIVE: "THIRTY_FIVE",
  FORTY: "FORTY",
  FORTY_FIVE: "FORTY_FIVE",
  FIFTY: "FIFTY",
} as const;
